import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { useCurrentOrganization } from 'src/store/organization';
import { generateJourneyAliasShareUrl } from 'src/utils/journey';
import { JourneyAliasFormType } from '../../form/link-config-form.factory';

interface Props {
  embedUrl: string;
}
const getLightboxScript = (
  url: string
) => `<script src="https://embed.journey.io/journey-lightbox.umd.js" async></script>
<a href="" onclick="JourneyLightbox.show('${url}');return false;">Show Journey</a>

<!-- Alternative with data attributes -->

<script src="https://embed.journey.io/journey-lightbox.umd.js" async></script>
<button data-journey-url="${url}">Show Journey</button>
`;

const getIframeCodeScript = (url: string) =>
  `<iframe style="border:0; min-width:360px;height:640px;width: 100%;" src="${url}" allowfullscreen allowtransparency></iframe>`;

export const ShareConfigEmbedCode = () => {
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  const { setSuccessNotification } = useNotificationMessage();

  const { values } = useFormikContext<JourneyAliasFormType>();

  const embedUrl = useMemo(
    () => generateJourneyAliasShareUrl(currentOrganization, values.slug),
    [currentOrganization, values]
  );

  const onCopyLightboxCodeClicked = () => {
    navigator.clipboard.writeText(getLightboxScript(embedUrl));
    setSuccessNotification('Copied the lightbox code to your clipboard');
  };

  const onCopyIframeCodeClicked = () => {
    navigator.clipboard.writeText(getIframeCodeScript(embedUrl));
    setSuccessNotification('Copied the iframe code to your clipboard');
  };

  return (
    <div className='flex flex-col divide-y text-bedrock-p'>
      <div className='flex flex-col space-y-sm pb-6'>
        <div className='text-bedrock-p-strong'>Lightbox</div>
        <span className='text-bedrock-p-small'>
          Place this code in your page’s HTML where you’d like the link to appear. When a user clicks on that link, your
          Journey will appear as a popup.
        </span>
        <button type='button' className='btn-bedrock-secondary w-full' onClick={onCopyLightboxCodeClicked}>
          Copy lightbox code
        </button>
      </div>
      <div className='flex flex-col space-y-sm pt-6'>
        <div className='text-bedrock-p-strong'>iFrame</div>
        <span className='text-bedrock-p-small'>Use this embed code to embed your journey on any website.</span>
        <button type='button' className='btn-bedrock-secondary w-full' onClick={onCopyIframeCodeClicked}>
          Copy iFrame code
        </button>
      </div>
    </div>
  );
};
